import type { PossibleTypesMap } from "@apollo/client"

export const paymentMethodPossibleTypes: PossibleTypesMap = {
  // TODO: Check what is this used for
  PaymentMethod: [
    "EngagementBankAccount",
    "PaymentMethodStripeAch",
    "PaymentMethodStripeBacs",
    "PaymentMethodStripeSepa",
  ],
}
